// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue"
import lodash from "lodash"
import localforage from "localforage"
import VeeValidate from "vee-validate"

import {
  Vuetify,
  VApp,
  VNavigationDrawer,
  VFooter,
  VList,
  VBtn,
  VIcon,
  VGrid,
  VToolbar,
  VSelect,
  VCombobox,
  VChip,
  VCard,
  VDataTable,
  VDialog,
  VStepper,
  VDivider,
  VTextField,
  VMenu,
  VAlert,
  VProgressLinear,
  VProgressCircular,
  VForm,
  VAvatar,
  VSwitch,
  VSubheader,
  VTooltip,
  VDatePicker,
  VTabs,
  VSnackbar,
  VCheckbox,
  VBtnToggle,
  VTextarea,
  VExpansionPanel,
  VRadioGroup,
  VAutocomplete,
  VHover,
  transitions
} from "vuetify"
import "../node_modules/vuetify/src/stylus/app.styl"
import "@/assets/tachyons.js"

import App from "@/App"
import router from "@/router"
import store from "@/store/index.js"

Vue.use(Vuetify, {
  components: {
    VApp,
    VNavigationDrawer,
    VFooter,
    VList,
    VBtn,
    VIcon,
    VGrid,
    VToolbar,
    VSelect,
    VCombobox,
    VChip,
    VCard,
    VDataTable,
    VDialog,
    VStepper,
    VDivider,
    VTextField,
    VMenu,
    VAlert,
    VProgressLinear,
    VProgressCircular,
    VForm,
    VAvatar,
    VSwitch,
    VSubheader,
    VTooltip,
    VDatePicker,
    VTabs,
    VSnackbar,
    VCheckbox,
    VBtnToggle,
    VTextarea,
    VExpansionPanel,
    VRadioGroup,
    VAutocomplete,
    VHover,
    transitions
  },
  theme: {
    primary: "#786bff",
    secondary: "#4655AD",
    accent: "#6DDDFF",
    error: "#EE3838",
    info: "#E4E5EC",
    success: "#5FD25A",
    warning: "#FFC107"
  }
})

Vue.config.productionTip = false
/* Make lodash an instance method */
Object.defineProperty(Vue.prototype, "$lodash", {
  value: lodash
})

/** Vee Validate */
Vue.use(VeeValidate)

/* Configure localforage */
localforage.config({
  name: "vop"
})

/* eslint-disable no-new */
new Vue({
  el: "#app",
  store: store,
  router: router,
  template: "<App/>",
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/main.js